import { render, staticRenderFns } from "./FormComponent.vue?vue&type=template&id=de15d54e&scoped=true&"
import script from "./FormComponent.vue?vue&type=script&lang=js&"
export * from "./FormComponent.vue?vue&type=script&lang=js&"
import style0 from "@/styles/form.less?vue&type=style&index=0&lang=less&"
import style1 from "./FormComponent.vue?vue&type=style&index=1&id=de15d54e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de15d54e",
  null
  
)

export default component.exports